module.exports = __webpack_public_path__ + "static/teaching-b55721200131c6f4c8dc86cca5f3ce81.gif";